// extracted by mini-css-extract-plugin
module.exports = {"top-zone-banners":"banners__top-zone-banners___1T9rM","is-colorful":"banners__is-colorful___22R6L"};